import { FormEvent, useState } from 'react'
import { Alerta, AreaTexto, Boton, Campo, Dialogo } from '../kit'
import { useMarcarNoUbicado } from '../../queries/useInventario'
import { Bien } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'

/** El bien no está donde dice el registro. El motivo es obligatorio: queda en el historial. */
export function DialogoNoUbicado({ bien, onCerrar }: { bien: Bien; onCerrar: () => void }) {
  const marcar = useMarcarNoUbicado()
  const [motivo, setMotivo] = useState('')
  const guardar = (e: FormEvent) => {
    e.preventDefault()
    marcar.mutate({ id: bien.id, motivo }, { onSuccess: onCerrar })
  }
  return (
    <Dialogo abierto onCerrar={onCerrar} titulo={`${bien.numero || bien.descripcion} no está aquí`}>
      <form className="pila" onSubmit={guardar}>
        <p className="texto-secundario">
          Queda como no ubicado en {bien.recinto?.nombre ?? 'su registro'}. Si aparece en otra oficina, se trae desde ahí.
        </p>
        <Campo etiqueta="Motivo" requerido ayuda="Dónde se buscó o qué se sabe del bien.">
          <AreaTexto rows={3} value={motivo} onChange={(e) => setMotivo(e.target.value)} required data-autofocus />
        </Campo>
        {marcar.isError && <Alerta tipo="error">{mensajeDeError(marcar.error)}</Alerta>}
        <div className="acciones-formulario">
          <Boton variante="text" onClick={onCerrar}>Cancelar</Boton>
          <Boton type="submit" color="error" cargando={marcar.isPending} disabled={!motivo.trim()}>Marcar no ubicado</Boton>
        </div>
      </form>
    </Dialogo>
  )
}
